import clsx from 'clsx'

import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface Props {
  routes?: string[]
}

export const UmrahFlight = ({ routes }: Props) => {
  return (
    <Paper padding={[14, 16, 14, 16]}>
      <div className={clsx('medium-14', s.container)}>
        {routes?.join(' → ')}
      </div>
    </Paper>
  )
}
